module.exports = __webpack_public_path__ + "static/img/SC2.90cc559.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/SC2.jpg
// module id = 7P18
// module chunks = 0